import './NotificationsButton.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import { useNotificationsContext } from '@/common/contexts/NotificationsContext/NotificationsContext';
import { ReactComponent as NotificationSvg } from '@/ebat/assets/icons/notification.svg';
import Notifications from '@/ebat/components/blocks/Header/Notifications/Notifications';
import {
  MENU_NAME_NOTIFICATIONS,
  MENU_TYPE_DRAWER,
} from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';
import useHeaderMenuToggle from '@/ebat/hooks/header/useHeaderMenuToogle';

import {
  NotificationsButtonDefaultProps,
  NotificationsButtonPropTypes,
} from './NotificationsButton.proptypes';

const NotificationsButton = ({ className }) => {
  const { t } = useTranslation();
  const { allNotifications } = useNotificationsContext();
  const { isOpen, handleToggle } = useHeaderMenuToggle(
    MENU_NAME_NOTIFICATIONS,
    MENU_TYPE_DRAWER,
    'right',
    <Notifications />,
  );

  return (
    <Button
      className={cn(className, 'notifications-button', {
        'notifications-button--open': isOpen,
      })}
      context="bottom-header-item-notifications"
      onClick={handleToggle}
    >
      <span className="notifications-button__container">
        <NotificationSvg className="notifications-button__icon" />
        <span className="notifications-button__label">
          {t('common:entities:layout.notifications.title')}
        </span>
        {allNotifications?.meta?.total_items_unread > 0 && (
          <span className="notifications-button__count">
            <span className="inner">
              {allNotifications?.meta?.total_items_unread}
            </span>
          </span>
        )}
      </span>
    </Button>
  );
};

NotificationsButton.defaultProps = {
  ...NotificationsButtonDefaultProps,
};

NotificationsButton.propTypes = {
  ...NotificationsButtonPropTypes,
};

export default NotificationsButton;
